'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"alloy-chiclet":"chiclet-module_alloy-chiclet__7ltmp","chiclet-text":"chiclet-module_chiclet-text__EaRq-","chiclet-default":"chiclet-module_chiclet-default__ZtUf4","chiclet-success":"chiclet-module_chiclet-success__I2EaW","chiclet-warning":"chiclet-module_chiclet-warning__dT7ft","chiclet-error":"chiclet-module_chiclet-error__DRNSF","chiclet-informational":"chiclet-module_chiclet-informational__BJSpf"};

exports.default = styles;
//# sourceMappingURL=chiclet.module.scss.js.map
